import script from "./FranchiseDataHub.vue?vue&type=script&setup=true&lang=js"
export * from "./FranchiseDataHub.vue?vue&type=script&setup=true&lang=js"

import "./FranchiseDataHub.vue?vue&type=style&index=0&id=7522923e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7522923e"]])

export default __exports__